/**
 * Utilitário para sinalizadores efêmeros de sessão (uma-vez-por-sessão).
 *
 * Persiste apenas um booleano em `sessionStorage`, namespaced por prefixo,
 * de forma segura contra ambientes onde o storage está indisponível
 * (modo privado, cota excedida, SSR). Nunca armazena dados sensíveis.
 */
const PREFIX = 'larah:session-flag:';

/**
 * Sanitiza a chave para conter apenas caracteres seguros de storage,
 * evitando colisões/injeção de chaves inesperadas a partir de entradas
 * dinâmicas (ex.: slug da loja).
 */
function buildKey(key: string): string {
  const safeKey = String(key).replace(/[^a-zA-Z0-9_-]/g, '_');
  return `${PREFIX}${safeKey}`;
}

/** Retorna `true` se o sinalizador já foi marcado nesta sessão. */
export function hasSeenThisSession(key: string): boolean {
  try {
    return sessionStorage.getItem(buildKey(key)) === '1';
  } catch {
    // Storage indisponível — trata como "ainda não visto".
    return false;
  }
}

/** Marca o sinalizador como visto nesta sessão. */
export function markSeenThisSession(key: string): void {
  try {
    sessionStorage.setItem(buildKey(key), '1');
  } catch {
    // Storage indisponível — ignora silenciosamente.
  }
}
